
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.125 3.75h13.75V5H4.125V3.75zm2.75 3.75h8.25v1.25h-8.25V7.5zm-2.75 3.75h13.75v1.25H4.125v-1.25zM6.875 15h8.25v1.25h-8.25V15z","fill":"#585858"}})])
          )
        }
      }
    